import formatCurrency from '@/utils/format-currency';

/** Guest-facing nightly rate row: "14 nights × $1,475.00". */
export const formatNightsRateLabel = (
  nights: number,
  nightlyRate: number
): string => {
  const nightLabel = nights === 1 ? 'night' : 'nights';
  return `${nights} ${nightLabel} × ${formatCurrency(nightlyRate, true)}`;
};
